module.exports = "../../ddd-architecture.jpg";